import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { LongPressDirective } from './long-press.directive';

@NgModule({
  declarations: [LongPressDirective],
  imports: [CommonModule, IonicModule, TranslateModule],
  exports: [LongPressDirective]
})
export class LongPressDirectiveModule { }
